import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { SupplierBillMasterData, SupplierBillMaster } from '../../../interfaces/pharmacy/SupplierBillMaster';
import { SupplierBillPaymentApi } from '../api/SupplierBillPayment.api';
@Injectable() 
export class SupplierBillService extends SupplierBillMasterData{
 
  constructor(private api: SupplierBillPaymentApi) {
    super();
  } 

  getall(url: string): Observable<SupplierBillMaster[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<SupplierBillMaster>{
      return this.api.getby_id(url);
  }

  create(url: string, data:SupplierBillMaster): Observable<SupplierBillMaster[]> {
    return this.api.add(url,data);
  }
  createInvSupp(url: string, data:any): Observable<any> {
    return this.api.addInvSupp(url,data);
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }
  searchList(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
    }

}